/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any) => ({
  // 엠베서더 가이드 설정 변경
  async update(data?: any) {
    return camelize(
      await $axios.patch(
        `/brand/ambassador/preferences/${data.id}`,
        snakelize(data)
      )
    );
  },
});
